<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="130px">
          <el-row>
            <el-col :span="8">
              <el-form-item
                label="业主姓名/联系电话"
                style="width: 80%"
              >
                <el-input
                  v-model="searchForm.keyword"
                  placeholder="请输入业主姓名/联系电话"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="报修编号"
                prop="orderWorkNo"
                style="width: 80%"
              >
                <el-input
                  v-model="searchForm.orderWorkNo"
                  placeholder="请输入报修编号"
                ></el-input>
              </el-form-item>
            </el-col>
             <!-- <el-col :span="8">
              <el-form-item
                label="报修区域"
                prop="type"
                style="width: 80%"
              >
                <el-select
                  clearable filterable
                  v-model="searchForm.type"
                  placeholder="请选择报修区域"
                >
                  <el-option :value="1" label="公共区域"></el-option>
                  <el-option :value="2" label="家庭"></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="8">
              <el-form-item
                label="报修状态"
                prop="status"
                style="width: 80%"
              >
                <el-select
                  clearable filterable
                  v-model="searchForm.status"
                  placeholder="请选择报修状态"
                >
                  <el-option :value="2" label="待完结"></el-option>
                  <el-option :value="3" label="已完结"></el-option>
                  <el-option :value="4" label="已评价"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button
                size="small"
                @click="onLoad(1)"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px"></div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="orderWorkNo" label="报修编号" align="center">
        </el-table-column>
        <el-table-column prop="orderWorkCategoryType" label="报修区域" align="center">
          <template slot-scope="scope">
            {{ scope.row.orderWorkCategoryType == 1?'公共区域':'家庭' }}
          </template>
        </el-table-column>
        <el-table-column prop="orderCategoryName" label="报修类型" align="center">
        </el-table-column>
        <el-table-column prop="des" label="报修内容" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="subscribeTime" label="期望维修日期" align="center">
          <template slot-scope="scope">
            {{ scope.row.subscribeTime.split(' ')[0] }}
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="业主姓名" align="center">
        </el-table-column>
        <el-table-column prop="phone" label="联系电话" align="center">
        </el-table-column>        
        <el-table-column prop="address" label="房屋信息" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center">
        </el-table-column>
        <el-table-column prop="status" label="工单状态" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 2" type="warning">待完结</el-tag>
            <el-tag v-if="scope.row.status == 3" type="success">已完结</el-tag>
            <el-tag v-if="scope.row.status == 4" type="info">已评价</el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="seeDetail(scope.row)"
              >查看</el-button
            >
            <el-button v-if="scope.row.status == 2" type="text" size="small" @click="completed(scope.row)"
              >去完结</el-button
            >
            <el-button @click="del(scope.row)" type="text"  size="small" color="red"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
       
      </div>
      <!-- 新增模态框 -->
      <el-dialog
        :title="diaTitle"
        :visible.sync="isAddModals"
        width="50%"
        :close-on-click-modal="false"
      >
        <el-form
          ref="form"
          :model="addData"
          label-width="120px"
          :rules="addDataRules"
          id="printTest"
          label-position="left"
          style="margin: 0 20px;"
        >
          <div v-if="diaTitle == '去完结'" style="padding-bottom: 20px;border-bottom: 1px solid #eee;margin-bottom: 20px;">
            <div class="mtitle">完结工单</div>
            <el-form-item label="">
              <el-radio-group v-model="addData.completeType">
                <el-radio :label="1">已完结</el-radio>
                <el-radio :label="2">已和业主沟通，无需维修</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="备注说明：">
              <el-input v-model="addData.completeRemark" :rows="5" type="textarea" maxlength="500" show-word-limit></el-input>
            </el-form-item>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="compleClick" :loading="btnLoading">确 定</el-button>
              <el-button @click="isAddModals = false">关 闭</el-button>
            </span>
          </div>
          <el-form-item label="报修区域：">
            <div>{{ addData.orderWorkCategoryType == 1?'公共区域':"家庭" }}</div>
          </el-form-item>
          <el-form-item label="报修类型：">
            <div>{{ addData.name }}</div>
          </el-form-item>
          <el-form-item label="详细报修内容：">
            <div>{{ addData.des }}</div>
          </el-form-item>
          <el-form-item label="上传的图片：">
            <div v-if="addData.img">
              <el-image style="width: 100px;height: 100px;margin: 0 10px 10px 0;" fit="cover" :src="item" v-for="(item,i) in addData.img.split(',')" :preview-src-list="addData.img.split(',')"></el-image>
            </div>
            
          </el-form-item>
          <el-form-item label="期望维修日期：">
            {{ addData.subscribeTime.split(' ')[0] }}
          </el-form-item>
          <el-form-item label="提交时间：">
            {{ addData.createTime }}
          </el-form-item>
          <el-form-item label="业主姓名：">
            {{ addData.userName }}
          </el-form-item>
          <el-form-item label="房屋信息：">
            {{ addData.address }}
          </el-form-item>
          <el-form-item label="联系电话：">
            {{ addData.phone }}
          </el-form-item>
          <el-form-item label="性别：">
            {{ addData.sex == 1?'男':'女' }}
          </el-form-item>
          <template v-if="addData.status == 3 || addData.status == 4">
            <div class="main">
              <el-form-item label="处理情况：">
                {{ addData.completeType == 1?'完结工单':'已和业主沟通，无需维修' }}
              </el-form-item>
              <el-form-item label="备注说明：">
                {{ addData.completeRemark }}
              </el-form-item>
              <el-form-item label="提交人：">
                {{ addData.manageUserName }}
              </el-form-item>
              <!-- <el-form-item label="联系电话">
                
              </el-form-item> -->
              <el-form-item label="处理时间：">
                {{ addData.completeTime }}
              </el-form-item>
            </div>
            <template v-if="addData.status == 4">
              <div class="main mtitle">评价详情</div>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="满意度打分：">
                    <div class="flex">
                      <el-rate
                        v-model="addData.score"
                        disabled
                        show-score
                        text-color="#ff9900"
                        score-template="{value}星">
                      </el-rate>
                    </div>
                    
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="服务打分：" >
                    <div class="flex">
                      <el-rate
                        v-model="addData.tdScore"
                        disabled
                        show-score
                        text-color="#ff9900"
                        score-template="{value}星">
                      </el-rate>
                    </div>
                    
                  </el-form-item>
                </el-col>
              </el-row>
              
              <el-form-item label="评价内容">
                {{ addData.evaluateContent }}
              </el-form-item>
              <el-form-item label="提交时间">
                {{ addData.evaluateTime }}
              </el-form-item>
            </template>
            <span slot="footer" class="dialog-footer">
              <el-button @click="isAddModals = false">关闭</el-button>
            </span>
          </template>
        </el-form>
        
      </el-dialog>
    </div>
  </div>
</template>

<script>
import store from "@/store";
export default {
  data() {
    return {
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      tableData: [],
      isShowloading: false,
      isAddModal: false,
      btnLoading: false,
      isAddModals: false,
      personList: [],
      addData: {
        manageUserId:"",
        subscribeTime:""
      },
      addDataRules: {
        
      },
      personList: [],
      searchForm: {
        orderWorkNo: "",
      },
      diaTitle:'详情'
      
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    completed(row) {
      this.$Apis.orderWorkDetail({
        orderWorkId:row.id
      }).then(res=>{
        if(res.code == 200){
          this.isAddModals = true;
          this.addData = res.data
          this.addData.completeType = 1
          this.addData.completeRemark = ''
          console.log(this.addData)
          this.diaTitle = '去完结'
          
        }
      })
     
    },
    compleClick(){
      this.btnLoading = true
      this.$Apis.orderWorkComplete({
        id:this.addData.id,
        completeType:this.addData.completeType,
        completeRemark:this.addData.completeRemark
      }).then(res=>{
        this.btnLoading = false
        if(res.code == 200){
          this.isAddModals = false
          this.$message.success('操作成功')
          this.onLoad()
        }else{
          this.$message.warning(res.msg)
        }
      })
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    seeDetail(row) {
      this.$Apis.orderWorkDetail({
        orderWorkId:row.id
      }).then(res=>{
        if(res.code == 200){
          this.isAddModals = true;
           this.addData = res.data
           this.diaTitle = '详情'
        }
      })
     
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    // 取消工单
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$Apis.orderWorkDdel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("删除成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        })
        .catch((err) => {});
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let { orderId, orderWorkCategoryId, subscribeTime, manageUserId,distributeTime} =
            this.addData;
          let data = {
            orderId,
            orderWorkCategoryId: orderWorkCategoryId.pop(),
            subscribeTime,
            manageUserId,
            distributeTime
          };
          this.$Apis.orderWorkDistribute(data).then((res) => {
            this.isAddModal = false;
            if (res.code == 200) {
              this.$message.success('分发成功')
              this.onLoad();
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },
    onLoad(ind) {
      this.isShowloading = true;
      this.currentPage = ind == 1 ? 1 : this.currentPage
      let page = {
        current: this.currentPage,
        size: this.pageSize,
        // type: 2,
        status: this.searchForm.status,
        orderWorkNo: this.searchForm.orderWorkNo,
        orderWorkId:this.$route.query.id || "",
        keyword:this.searchForm.keyword
      };
      this.tableData = [];
      this.$Apis.orderWorkList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
          store.commit("setMsgPoint", this.total);
        }
      });
      
    },
  },
};
</script>

<style  scoped>
/deep/.el-input.is-disabled .el-input__inner{
  color: #333;
  font-weight: bold;
  border: none;
  background: #fff;
}
/deep/ .el-textarea.is-disabled .el-textarea__inner{
  color: #333;
  font-weight: bold;
  border: none;
  background: #fff;
}
.flex{
  display: flex;
  align-items: center;
  height: 40px;
}
.main{
  padding-top: 30px;
  border-top: 1px solid #eee;
}
.mtitle{
  font-size: 18px;
  /* padding-left: 40px; */
  font-weight: bold;

}
.dialog-footer{
  display: flex;
  justify-content: center;
}
</style>